module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Kitchen-scale-04a8683c01276cdbb56f39395103de8c.svg";